module.exports = __webpack_public_path__ + "img/markus-spiske-computer-datas-unsplash.fd27bc39.jpg";